import React from 'react'
import '../banner/Banner.css'
import { Col, Container, Row } from 'react-bootstrap'

const Banner = () => {
  return (
    <>
        <section id="banner">
            <Container>
                <Row>
                    <Col lg={7}>
                        <div class="banner_text">
                            <h1>
                                ORGANIC FLAVORS <br/>
                                FROM <span>FARM</span> 
                            </h1>
                            <p>Donec sollicitudin molestie malesuada. <br/>Lorem ipsum dolor sit amet,consectetur <br/>adipiscing elit.</p>
                            <button class="shop_now">shop now</button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    </>
  )
}

export default Banner